/* ============================================================
   QR PRODUCT LANDING — File: assets/qr-product-landing.js
   ============================================================ */
(function () {
  function init(section) {
    const items = Array.from(section.querySelectorAll('.qrl-faq-item'));
    items.forEach(function (item) {
      const q = item.querySelector('.qrl-faq-q');
      const a = item.querySelector('.qrl-faq-a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        const isOpen = item.classList.contains('open');
        items.forEach(function (other) {
          other.classList.remove('open');
          const oa = other.querySelector('.qrl-faq-a');
          if (oa) oa.style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }
  function initAll() { document.querySelectorAll('.qrl').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    const s = e.target.querySelector('.qrl'); if (s) init(s);
  });
})();
